module.exports = __webpack_public_path__ + "static/favicon-7a90c5bb004c0ade78ae2e6e60bc121d.ico";